import React from "react";
// router
import { useLocation, useParams } from "react-router";
// redux
import { useSelector } from "react-redux";
// components
import PageLayout from "../../components/layout/PageLayout";
import PageTitle from "../../components/page/PageTitle";
import NavigationBack from "../../components/navigation/NavigationBack";
import ThreeDotsLoader from "../../components/loader/ThreeDotsLoader";
import ErrorSection from "../../components/alerts/ErrorSection";
import NoItems from "../../components/alerts/NoItems";
import LinkButton from "../../components/buttons/LinkButton";
import FiltersContainer from "../../components/filters/FiltersContainer";
import SearchBox from "../../components/filters/SearchBox";
import SortBox from "../../components/filters/SortBox";
import IsDisabledFilterBox from "../../components/filters/IsDisabledFilterBox";
import DataTable from "../../components/table/DataTable";
// mui
import { Stack } from "@mui/system";
// hooks
import usePageParams from "../../hooks/usePageParams";
import useSortParams from "../../hooks/useSortParams";
import useQParams from "../../hooks/useQParams";
import useFilterParams from "../../hooks/useFilterParams";
// columns
import { offerColumns } from "./offerColumns";
// fetching
import fetching from "../../helpers/fetching/fetching";
import { useQuery } from "@tanstack/react-query";
// types
import type { BusinessOffer, UserState } from "../../types/types";

const BusinessOffers = ({
  showAddButton = true,
}: {
  showAddButton?: boolean;
}) => {
  const userToken = useSelector((state: UserState) => state.user.userToken);
  const location = useLocation();
  const { page } = usePageParams();
  const { sort } = useSortParams();
  const { search } = useQParams();
  const { isDisabled } = useFilterParams();

  const itemsPerPage = 20;

  const { business_id } = useParams();

  function getBusinessOffers() {
    let endpoint = `/business-offers?page=${page}&paginate=${itemsPerPage}&sorts=${sort}&q=${search}&filters=${isDisabled}`;
    if (business_id) {
      endpoint += `,business_id:eq:${business_id}`;
    }
    return fetching(endpoint, userToken)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          throw data.message;
        }
        return data;
      });
  }

  const {
    data: offers,
    isLoading,
    isError,
    error,
  } = useQuery<{ data: BusinessOffer[]; meta: any }, Error>({
    queryKey: ["business-offers", page, sort, search, isDisabled],
    queryFn: getBusinessOffers,
  });

  return (
    <PageLayout>
      <NavigationBack
        links={[{ to: `/businesses`, label: "الانشطة التجارية و الخدمة" }]}
      />
      <PageTitle title={`عروض النشاط`} />
      {showAddButton && (
        <LinkButton
          label="اضافة عرض الي نشاط تجاري"
          to={`/businesses/${business_id}/offers/add`}
        />
      )}
      <FiltersContainer>
        <SearchBox />
        <SortBox />
        <IsDisabledFilterBox />
      </FiltersContainer>
      <Stack>
        {isError ? (
          <ErrorSection errorMsg={error.toString()} />
        ) : isLoading ? (
          <ThreeDotsLoader />
        ) : offers?.data?.length === 0 ? (
          <NoItems />
        ) : (
          <DataTable
            rows={offers?.data || []}
            columns={
              location.pathname != "/offers"
                ? offerColumns.filter((col) => col.field != "business_name")
                : offerColumns
            }
            itemsPerPage={itemsPerPage}
            totalItems={isLoading ? 0 : offers?.meta?.total}
          />
        )}
      </Stack>
    </PageLayout>
  );
};

export default BusinessOffers;
